module.exports = __webpack_public_path__ + "img/tw.5e5e0926.svg";